import React from "react";
import { compose } from 'redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/styles';

import withShowToast from '../../../../hocs/with_show_toast.js';
import I18n from "../../../../base/i18n.js.jsx";

import MoneyFormatter from "../../../../utils/money_formatter.js";
import LoadTotalInvestmentsUseCase from "../../../../use_cases/statistics/investments/load_total_investments_use_case.js";

import IcCoins from "../resources/icons/ic_coins.js.jsx";
import IcPercent from "../resources/icons/ic_percent.js.jsx";
import IcMoney from "../resources/icons/ic_money.js.jsx";

const styles = theme => ({
  circular: {
    display: "block",
    margin: "20px auto"
  },
  stats: {
    background: theme.palette.grayBg,
    borderRadius: "2px",
    display: "flex",
    padding: "32px 0",
    width: "50%",
    marginBottom: "77px",
    ['@media (max-width: 992px)']: {
      padding: "16px 0",
      marginBottom: "30px",
    }
  },
  statsCol: {
    display: "flex",
    alignItems: "center",
    flex: "0 1 50%",
    padding: "0 70px",
    width: "50%",
    "&:not(:last-child)": {
      borderRight: `1px solid ${theme.palette.grayDisable}`,
    },
    ['@media (max-width: 992px)']: {
      flexDirection: "column",
      padding: "0 14px",
      textAlign: "center",
    }
  },
  statsIcon: {
    height: "60px",
    width: "60px",
    margin: "0 26px 0 0",
    ['@media (max-width: 992px)']: {
      height: "26px",
      width: "26px",
      margin: "0 0 9px"
    }
  },
  statsText: {
    fontSize: "16px",
    color: theme.palette.grayText,
    lineHeight: "1.25",
    margin: "0",
    ['@media (max-width: 992px)']: {
      fontSize: "10px",
      lineHeight: "1.4"
    }
  },
  statsVal: {
    fontSize: "24px",
    lineHeight: "1.25",
    marginBottom: "8px",
    ['@media (max-width: 992px)']: {
      fontSize: "16px",
      marginBottom: "6px",
    }
  }
})

class InvestmentsStatsBlock extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    LoadTotalInvestmentsUseCase.execute()
    .then(result => {
      this.setState({
        loading: false,
        investments: result.data.statistics.investments
      })
    })
    .catch((result) => {
      this.setState({
        loading: false
      });
      this.props.showServerErrorIfNeed(result);
    });
  }  

  render() {
    const { classes } = this.props
    const { loading, investments } = this.state
    const { 
      totalAmountInvestments = "0", 
      totalAmountOfInterestPending = "0", 
      totalAmountOfInterestReceived = "0"
    } = investments || {};

    return <React.Fragment>
      { loading && <CircularProgress className = { classes.circular }/> }
      { !loading &&
        <React.Fragment>
          <div className = { classes.stats }>
            {/* <div className = { classes.statsCol }> */}
              <IcMoney className = { classes.statsIcon } />
              <div>
                <div className = { classes.statsVal }>
                  { `${MoneyFormatter.format(totalAmountInvestments)} ${I18n.t("currency.euro")}` }
                </div>
                <p className = { classes.statsText }>
                  { I18n.t("web.page.profile.statistics.total_investments") }
                </p>
              {/* </div> */}
            </div>
            {/* <div className = { classes.statsCol }>
              <IcPercent className = { classes.statsIcon } />
              <div>
                <div className = { classes.statsVal }>
                  { `${MoneyFormatter.format(totalAmountOfInterestPending)} ${I18n.t("currency.euro")}` }
                </div>
                <p className = { classes.statsText }>
                  { I18n.t("web.page.profile.statistics.pending_interests") }
                </p>
              </div>
            </div>
            {false && <div className = { classes.statsCol }>
              <IcCoins className = { classes.statsIcon } />
              <div>
                <div className = { classes.statsVal }>
                  { `${MoneyFormatter.format(totalAmountOfInterestReceived)} ${I18n.t("currency.euro")}` }
                </div>
                <p className = { classes.statsText }>
                  { I18n.t("web.page.profile.statistics.received_interest") }
                </p>
              </div>
            </div>} */}
          </div>
        </React.Fragment> 
      }
    </React.Fragment>
  }
}

export default compose(withShowToast, withStyles(styles))(InvestmentsStatsBlock);
